<div class="container-fluid" style="background-color: #1d2229">
    <div class="row">
        <div class="col-sm-2">
            <div class="content">
                <div class="container-lg text-center" style="background-color: #1d2229">
                    <div class="row">
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 41]" 
                                [ngStyle]="{ color: statusDocks(41) }">
                                Doca 1
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 42]"
                                [ngStyle]="{ color: statusDocks(42) }">
                                Doca 2
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 43]"
                                [ngStyle]="{ color: statusDocks(43) }">
                                Doca 3
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 44]"
                                [ngStyle]="{ color: statusDocks(44) }">
                                Doca 4
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-10">
            <router-outlet></router-outlet>
        </div>

    </div>
</div>
